import React from 'react';
import { space } from 'styled-system';
import { styled } from '@teko/ui';

const getColor = (props) => {
    const { color, theme } = props;
    return ((color && (theme.brand[color] || theme.colors[color])) ||
        color ||
        theme.colors.dark);
};
const StyledText = styled.div(space, (props) => {
    return `
    color: ${getColor(props)};
    font-weight: ${props.fontWeight || '400'};
    font-size: ${props.fontSize || 14}px;
    ${props.lineHeight ? ` line-height: ${props.lineHeight}px;` : ''}
    text-align: ${props.textAlign || 'left'};
    overflow: hidden;
    ${props.maxLines
        ? `text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: ${props.maxLines};`
        : ''}
    ${props.textTransform
        ? `
      text-transform: ${props.textTransform};
    `
        : ''}
  `;
});
const Text = (props) => {
    return React.createElement(StyledText, Object.assign({}, props));
};

export { Text as T };
